import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewChild} from '@angular/core';
import {OpenDialogService} from "../../providers/service/open-dialog.service";
import {stringIsSet} from "../../providers/service/global-variables.service";
import {BehaviorSubject, combineLatest, Observable, Subject} from "rxjs";
import {map} from "rxjs/operators";

@Component({
    selector: 'app-truncate-text',
    templateUrl: './truncate-text.component.html',
    styleUrls: ['./truncate-text.component.scss'],
    standalone: false
})
export class TruncateTextComponent implements OnInit, AfterViewInit {
    textEmit = new BehaviorSubject<string | undefined>(undefined)
    text$: Observable<string | undefined>
    maxRowsEmit = new BehaviorSubject<number>(1)
    maxRows$: Observable<number>
    textTruncate$: Observable<string | undefined>
    showOther$: Observable<boolean>

    @Input() set maxRows(value: number | undefined) {
        this.maxRowsEmit.next(value != null ? value : 1)
    }

    get maxRows() {
        return this.maxRowsEmit.value
    }

    @Input() set text(value: string | undefined) {
        this.textEmit.next(value)
    }

    get text() {
        return this.textEmit.value
    }

    @Input() title: string | undefined;
    @Input() subTitle: string | undefined;
    @Input() mindValue: string = ' ... ';
    @ViewChild('FATHER', {static: false}) private fatherDiv: ElementRef<HTMLDivElement> | undefined;
    @ViewChild('CHILD', {static: false}) private spanChild: ElementRef<HTMLSpanElement> | undefined;

    constructor(private openDialog: OpenDialogService,
                private render2: Renderer2) {
        this.text$ = this.textEmit.asObservable()
        this.maxRows$ = this.maxRowsEmit.asObservable()

        this.textTruncate$ = combineLatest([this.text$, this.maxRows$]).pipe(
            map(([text, maxRows]) => {
                if (this.spanChild && this.spanChild.nativeElement && this.fatherDiv && this.fatherDiv.nativeElement) {
                    const sizeSingleCharacter = this.getSize('A', this.spanChild?.nativeElement!)
                    const totalTextWidth = this.spanChild?.nativeElement.offsetWidth
                    const numberRows = Math.floor(this.spanChild?.nativeElement.offsetHeight / sizeSingleCharacter.height)
                    const maxWidth = this.fatherDiv?.nativeElement.clientWidth!
                    if (stringIsSet(text) && (((totalTextWidth != null && maxWidth != null) && (totalTextWidth > maxWidth)) || numberRows > maxRows)) {
                        const widthSingleCharacter = sizeSingleCharacter.width
                        const widthThreeCharacter = this.getSize(this.mindValue, this.spanChild?.nativeElement!).width
                        // as if they were on a single linex
                        let widthAvaiable = maxWidth * maxRows - widthThreeCharacter;
                        const numberCharacter = Math.floor(widthAvaiable / widthSingleCharacter);
                        const lastIndexInitText = Math.floor(numberCharacter / 2)
                        const firstIndexLastText = this.text?.length! - lastIndexInitText;
                        const truncateText = text?.substring(0, lastIndexInitText) + this.mindValue + text?.substring(firstIndexLastText, text?.length)
                        return truncateText
                    }
                }
                return text
            })
        );
        this.showOther$ = this.textTruncate$.pipe(
            map(text => text != this.text)
        )
    }

    ngOnInit(): void {
    }

    ngAfterViewInit() {
        const text = this.text
        setTimeout(() => {
            this.text = text
        }, 0)
        // Now that you know which div is shown, you can run whatever piece of code you want
    }

    clickOther() {
        const values: {
            title: { traduction?: string, value?: any },
            value: { traduction?: string, value?: any }
        }[] = [];
        const title = {traduction: this.title};
        const value = {value: this.text};
        values.push({title, value});
        this.openDialog.openShowRawDetail(values, this.subTitle, false).subscribe();
    }


    createDummyElement(text: string, nativeElement: HTMLElement): HTMLElement {
        const element = this.render2.createElement('span')
        const textNode = document.createTextNode(text)
        element.appendChild(textNode)
        if (nativeElement) {
            const keys = [
                'fontFamily',
                'fontSize',
                'fontWeight',
                'lineHeight',
                'width',
                'wordBreak',
            ]
            keys.forEach((key: any) => {
                this.render2.setStyle(element, key, nativeElement.style[key])
            })

            this.render2.setStyle(element, 'position', 'absolute')
            this.render2.setStyle(element, 'visibility', 'hidden')
            this.render2.setStyle(element, 'left', '-999px')
            this.render2.setStyle(element, 'top', '-999px')
            this.render2.setStyle(element, 'height', 'auto')
            document.body.appendChild(element)
        }
        return element
    }

    destroyElement(element: HTMLElement): void {
        element.parentNode?.removeChild(element)
    }

    getSize(text: string, nativeElement: HTMLElement): Size {
        // prepare options
        const element = this.createDummyElement(text, nativeElement)
        const size = {
            width: element.offsetWidth,
            height: element.offsetHeight,
        }
        this.destroyElement(element)
        return size
    }


}

export interface Size {
    width: number
    height: number
}
